import { Component, ViewEncapsulation } from '@angular/core';
import { MessageServiceComponent } from '../../services/message.service'

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.css'],
  encapsulation: ViewEncapsulation.ShadowDom
})
export class SpinnerComponent {
  constructor(public messageServiceComponent: MessageServiceComponent) { }
}